@use "../../../sass/global/global" as *;

/**
@prop --card-padding: Inner padding of the card content area (default `30px`)
 */
:host {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: var(--card-padding, 30px);
    @include font(light);
}

:host([no-padding]) {
    padding: 0;
}

.label {
    display: block;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    text-transform: uppercase;
    margin-bottom: 10px;
    @include font(bold);
}
